import axios from 'axios';

const API_BASE_URL = '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const fetchKeywords = async (params = {}) => {
  try {
    // 清理参数：移除空值
    const cleanParams = {};
    if (params.query) cleanParams.query = params.query;
    if (params.years && params.years.length > 0) cleanParams.years = params.years.join(',');
    if (params.category) cleanParams.category = params.category;

    const response = await api.get('/api/keywords', { params: cleanParams });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return [];
  }
};

export const fetchKeywordDetail = async (id) => {
  try {
    const response = await api.get(`/api/keywords/${id}`);
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return null;
  }
};

export const fetchCorpus = async (params = {}) => {
  try {
    // 清理参数
    const cleanParams = {};
    if (params.keyword_id) cleanParams.keyword_id = params.keyword_id;
    if (params.page) cleanParams.page = params.page;
    if (params.page_size) cleanParams.page_size = params.page_size;
    if (params.topic) cleanParams.topic = params.topic;
    if (params.sentiment) cleanParams.sentiment = params.sentiment;
    if (params.year) cleanParams.year = params.year;
    if (params.source) cleanParams.source = params.source;
    if (params.search) cleanParams.search = params.search;

    const response = await api.get(`/api/corpus`, { params: cleanParams });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return { items: [], total: 0 };
  }
};

export const fetchStats = async () => {
  try {
    const response = await api.get('/api/stats');
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return {};
  }
};

export const fetchCorpusDetail = async (id) => {
  try {
    const response = await api.get(`/api/corpus/${id}`);
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return null;
  }
};

export const fetchKeywordYears = async (keywordId) => {
  try {
    const response = await api.get(`/api/keywords/${keywordId}/years`);
    return response.data; // [{ year: '2024', count: 31 }, ...]
  } catch (error) {
    console.error('API Error:', error);
    return [];
  }
};


export const fetchCorpusStats = async (keywordId) => {
  try {
    const response = await api.get('/api/corpus/stats', { params: { keyword_id: keywordId } });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return { sentiments: {}, total: 0 };
  }
};

export const fetchTrends = async (keywordId) => {
  try {
    const response = await api.get('/api/analytics/trends', { params: { keyword_id: keywordId } });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return { trends: {} };
  }
};

export const fetchSources = async (keywordId) => {
  try {
    const response = await api.get('/api/analytics/sources', { params: { keyword_id: keywordId } });
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return { sources: [] };
  }
};


export const fetchKeywordFilters = async (keywordId) => {
  try {
    const response = await api.get(`/api/keywords/${keywordId}/filters`);
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    return { topics: [], sentiments: [] };
  }
};
